<template>
  <v-container fluid>
    <div class="d-flex align-center mb-4">
      <div>
        <h2>Development Mode</h2>
        <div class="grey--text">Customer-scoped catalog diagnostics for this business</div>
      </div>
      <v-spacer />
      <v-btn color="primary" rounded :loading="loading" @click="load">Refresh</v-btn>
    </div>

    <v-card outlined>
      <v-card-text class="d-flex flex-wrap align-center" style="gap: 12px">
        <CustomerAutoComplete v-model="customer" :initValue="customer" style="min-width: 300px" />
        <v-select v-model="eventType" :items="eventTypes" label="Event" clearable outlined dense hide-details style="max-width: 260px" />
        <v-btn text @click="clearFilters">Clear filters</v-btn>
      </v-card-text>
      <v-data-table :headers="headers" :items="rows" :loading="loading" :items-per-page="50">
        <template v-slot:item.createdAt="{ item }">{{ item.createdAt | moment("MM/DD/YYYY hh:mm:ss A") }}</template>
        <template v-slot:item.Customer="{ item }">{{ item.Customer ? item.Customer.name : "—" }}</template>
        <template v-slot:item.statusCode="{ item }">{{ item.statusCode || "—" }}</template>
        <template v-slot:item.details="{ item }"><code class="diagnostic-details">{{ formatDetails(item.details) }}</code></template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import CustomerAutoComplete from "@/modules/Customer/components/AutoComplete";
import service from "../service";

export default {
  components: { CustomerAutoComplete },
  data: () => ({
    loading: false, customer: null, eventType: null, rows: [],
    eventTypes: ["unexpected_reload", "products_failed", "storage_failed", "app_error", "products_loaded", "category_select", "catalog_open", "catalog_close", "update_deferred", "network_offline", "network_online"],
    headers: [
      { text: "Time", value: "createdAt", width: 190 },
      { text: "Customer", value: "Customer" },
      { text: "Event", value: "eventType" },
      { text: "Category", value: "categoryName" },
      { text: "Products", value: "productCount" },
      { text: "ms", value: "durationMs" },
      { text: "HTTP", value: "statusCode" },
      { text: "Session", value: "sessionId" },
      { text: "Details", value: "details", sortable: false },
    ],
  }),
  computed: { ...mapGetters("global", ["currentUser"]) },
  watch: { customer: "load", eventType: "load" },
  created() {
    if (!this.currentUser || !this.currentUser.isAdmin) return this.$router.replace("/");
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const response = await service.getAll({ limit: 500, CustomerId: this.customer && this.customer.id, eventType: this.eventType });
        this.rows = response.data.data || response.data || [];
      } catch (error) {
        this.rows = [];
        this.$swal("Diagnostics", "Unable to load diagnostic events", "error");
      } finally { this.loading = false; }
    },
    clearFilters() { this.customer = null; this.eventType = null; },
    formatDetails(value) {
      if (!value) return "";
      try { return JSON.stringify(JSON.parse(value)); } catch (error) { return value; }
    },
  },
};
</script>

<style scoped>.diagnostic-details { white-space: normal; word-break: break-word; font-size: 11px; }</style>
